import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "link" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "count" }
const _hoisted_4 = {
  key: 0,
  class: "label"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar-item pointer", {active: $props.active}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Icon, {
              stroke: "var(--gray-500)",
              "stroke-width": "1.2",
              icon: $props.icon,
              size: "1.8rem"
            }, null, 8 /* PROPS */, ["icon"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", {
        class: _normalizeClass(["title", {smaller: $props.level === 2}])
      }, _toDisplayString($props.title), 3 /* TEXT, CLASS */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($props.store)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.store.total), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass([{opened: $props.opened}, "arrow"])
      }, [
        ($props.children)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              stroke: "var(--gray-500)",
              icon: "chevron-down",
              size: "1.8rem",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('arrow')), ["stop","prevent"]))
            }))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ], 2 /* CLASS */))
}